<template>
  <div class="login" dir="rtl">
    <div class="square" style="background: #3491ef;"></div>
    <img src="../../../public/img/zoodkomak.png">
    <div class="login-card-outer" ref="form" style="max-width: 450px;background: white !important;padding:15px 15px 30px 15px;border-radius: 8px;box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; ">

      <div class="login-card" style="border: none !important;">
        <div class="relative">
          <v-icon>
            mdi-cellphone-iphone
          </v-icon>
          <v-text-field
            ref="mobile"
            :label="$t('mobileNo')"
            v-model="mobile"
            hint="09123456789"
            outlined

            required
          ></v-text-field>
          <!--            :rules="[rules.required, rules.mobile]"-->
        </div>
        <div class="relative" v-if="level==1">
          <v-icon>
            mdi-account
          </v-icon>
          <v-text-field v-if="$i18n.locale=='fa'"
                        ref="fullName"
                        :label="$t('fullName')"
                        v-model="fullName"
                        :rules="[
                () => !!fullName || 'الزامی',
                 () => fullName.length <= 30 || 'ماکسیمم 30 کاراکتر می باشد.',
                () => {
                  const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئكيدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
                  return pattern.test(fullName) || 'نام و نام خانوادگی فارسی نیست.'
                },

              ]"
                        outlined
                        required
          ></v-text-field>
          <v-text-field  v-if="$i18n.locale!='fa'"
                         ref="fullName"
                         :label="$t('fullName')"
                         v-model="fullName"
                         outlined
                         required
          ></v-text-field>
        </div>
        <div class="relative" v-if="level==2">
          <v-icon>
            mdi-account
          </v-icon>
          <v-text-field
            :label="$t('sendedCode')"
            v-model="password"
            :rules="[rules.required]"
            outlined
          ></v-text-field>
        </div>
      </div>
      <div>
        <button class="btn login-btn" style="background: #3491ef !important;border-radius: 8px;width: 100%" v-on:click="login()" :disabled="!valid">{{ $t('login') }}</button>
      </div>

    </div>
  </div>
</template>
<script>
  /* eslint-disable */
  import {bus} from '../../main.js'

  export default {
    data() {
      return {
        errors: [],
        mobile: '',
        fullName: '',
        password: '',
        valid: true,
        level: 1,
        rules: {
          required: value => !!value || this.$t('required'),
          fullName: value => value.length <= 30 || this.$t('maximumChar'),


        },
        formHasErrors: false,
      }
    },
    computed: {
      form() {
        return {

          mobile: this.mobile,
          fullName: this.fullName,
          // city: this.city,
          // state: this.state,
          // zip: this.zip,
          // country: this.country,
        }
      },
    },
    methods: {
      login() {
      // ٠١٢٣٤٥٦٧٨٩
      //   bus.$emit('show_toast', [1500, this.mobile.toString()])
     // this.rules.required();
        var self = this;

        if (this.level == 1) {
          this.formHasErrors = false
          var k = 0;

          Object.keys(this.form).forEach(f => {
            if (!this.form[f]) {
              this.formHasErrors = true
            }
            // this.$refs[f].validate(true)
            if (this.$refs[f].validate() == true) {
              k = k + 1;
            }
          })
          if (k == 2) {
            var eddited_mobile = this.persian_to_english(this.mobile)
            if(!eddited_mobile.startsWith(0) && eddited_mobile.length==10){
              eddited_mobile="0"+eddited_mobile
            }
        console.log("edited mobile is ",eddited_mobile)
            const send_data = {
              "Phone": eddited_mobile,
              "Name": this.fullName
            };
            // this.axios.post('/Register' , send_data,{
            this.axios.post('/Register', send_data, {})
              .then(response => {
                if (response.data.error == 0) {
                  // console.log("response", response);
                  bus.$emit('show_toast', [2000, response.data.msg])
                  self.level = 2;
                }
                // this.$router.push({ path: "/post-login", params: {} });

              }).catch(e => {
              self.errors.push(e);
              bus.$emit('show_toast', [2000, e])

            })
          }

        } else if (this.level == 2) {
          // this.$refs.form.validate();
          this.technician_login();
        }
      },
      technician_login() {
        var self = this;
        var eddited_mobile = this.persian_to_english(this.mobile)

        if(!eddited_mobile.startsWith(0) && eddited_mobile.length==10){
          eddited_mobile="0"+eddited_mobile
        }
         eddited_mobile = eddited_mobile.substring(1);
        eddited_mobile = "+98" + eddited_mobile;
        if (eddited_mobile != '' && this.fullName != '') {

          const send_data = {
            "MobileNo": this.persian_to_english(eddited_mobile),
            "Password": this.persian_to_english(this.password),
            "OsName": "PWA",
            "AppNo": "4",
            "OsVersion": "1",
            "DeviceModel": "android",
          };
          // this.axios.post('/Register' , send_data,{
          this.axios.post('/TechnicianLogin', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                console.log("response login", response);

                localStorage.setItem("profile", JSON.stringify(response.data.profile))
                localStorage.setItem("phone", self.persian_to_english(eddited_mobile))
                localStorage.setItem("password", self.persian_to_english(self.password))

                self.$router.push({path: "/post-login", params: {}});
                bus.$emit('show_toast', [2000, response.data.msg])

              } else {
                bus.$emit('show_toast', [2000, response.data.msg])
              }

            }).catch(e => {
            self.errors.push(e);
            bus.$emit('show_toast', [2000, e])

          })
        }
      },

    },
  }
</script>
